import type { ChapterTexts } from './types'
import { t } from '@/i18n/utils'

/**
 * Chapter 页面通用文案配置
 * 三个品牌共用的默认文案
 */
export const commonTexts: ChapterTexts = {
  get loading() { return `${t('Loading')}...` },
  get unlockTitle() { return t('Unlock') },
  get unlockDesc() { return t('UnlockIncentive') },
  // 与 en.json 不完全匹配（占位符格式不同 {coins} vs {0}）
  get unlockChapterButton() { return t('unlockChapterButton') },
  // 与 en.json 不完全匹配（占位符格式不同）
  get unlockBookButton() { return t('unlockBookButton') },
  get continueInApp() { return t('ToApp') },
  get autoUnlock() { return t('AutoUnlock') },
  // 与 en.json 不完全匹配（占位符格式不同）
  get coinsBalance() { return t('coinsBalance') },
  get prevButton() { return t('Prev') },
  get nextButton() { return t('Next') },
  get unlockButton() { return t('Unlock2') },
  get catalogueButton() { return t('Catalogue') },
  get themeSizeLabel() { return t('Size') },
  // 固定值，不翻译
  fontSizeDecrease: 'A-',
  fontSizeIncrease: 'A+',
  get coinsSuccessTitle() { return t('Congratulations') },
  get coinsSuccessDesc1() { return t('UnlimitedReadingDuring') },
  get coinsSuccessDesc2() { return t('UnlimitedReadingIncentive') },
  get coinsSuccessButton() { return t('OK') },
  get recommendTitle() { return t('Retention') },
  get recommendSeeAll() { return t('SeeAll') },
  get payTemplateTitle() { return t('ChapterLocked') },
  get payTemplateDesc() { return t('SelectGuide') },
  get payTemplateCoins() { return t('coins') },
  // 与 en.json 不完全匹配
  get payTemplateFree() { return t('payTemplateFree') },
  // 与 en.json 不完全匹配（占位符格式不同）
  get payTemplateGetCoins() { return t('payTemplateGetCoins') },
  // 与 en.json 不完全匹配（占位符格式不同）
  get payTemplateEarnCoins() { return t('payTemplateEarnCoins') },
}
